import React, { FC, useEffect } from 'react'
import ReactDOM from 'react-dom';

import "./PageLoader.css";

export type PageLoaderProps = {
    show: boolean;
    fullscreen?: boolean;
    className?: string;
};

const PageLoader: FC<PageLoaderProps> = ({ show, fullscreen = false, className }) => {

    // Prevent body scroll if fullscreen loader is visible
    useEffect(() => {
        if (fullscreen && show) {
            const original = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
            return () => {
                document.body.style.overflow = original;
            };
        }
    }, [fullscreen, show]);

    if (!show) return null;

    
    function cn(...args: Array<string | false | null | undefined>) {
    return args.filter(Boolean).join(' ');
    }


    const loaderContent = (
        <div
            className={cn(
                'pl__container',
                fullscreen ? 'pl__container--fullscreen' : 'pl__container--inline',
                className
            )}
            role="status"
            aria-live="polite"
            aria-busy="true"
            aria-label={fullscreen ? 'Loading page' : 'Loading'}
        >
            <div className="pl__spinner" aria-hidden="true" />
            <span className="pl__text">Loading…</span>
        </div>
    );

    // Render into a portal when fullscreen so it escapes layout/z-index issues
    if (fullscreen) {
        return ReactDOM.createPortal(loaderContent, document.body);
    }

    return loaderContent;
}

export default PageLoader